/**
 * Determines whether or not an element has the virtual hierarchy extension.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isVirtualElement", {
    enumerable: true,
    get: ()=>isVirtualElement
});
function isVirtualElement(element) {
    return element && !!element._virtual;
} //# sourceMappingURL=isVirtualElement.js.map

//# sourceMappingURL=isVirtualElement.js.map